export default abstract class ModulesStateBasic {

    /** 随机key */
    public key: number;
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-scaffold-framework/modules/ModulesStateBasic/index.ts